import { render, staticRenderFns } from "./LocaleSwitcher.vue?vue&type=template&id=6498e6a8&"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=ts&"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports